<template>
	<div class="pages">
		<sub-ibox-title><p slot="title">公众号接入</p></sub-ibox-title>
		<div class="p-20 from bor-top-none">
			<div class="">
				<a class="z-btn z-btn-primary b-r-3" @click="handleAuth">{{publicInfo?'重新授权公众号':'立即接入公众号'}}</a>
			</div>
			<div class="p-t-15" v-if="publicInfo">
				<h5>{{publicInfo.nick_name}}公众号，已授权皮休管家平台！</h5>
				<div class="p-t-10">
					<h6>皮休管家平台已获得如下权限：</h6>
					<ul class="m-t-10">
						<li><i class="icon-gou p-r-10"></i>消息管理权限</li>
						<li><i class="icon-gou p-r-10"></i>自定义菜单权限</li>
						<li><i class="icon-gou p-r-10"></i>网页服务权限</li>
						<li><i class="icon-gou p-r-10"></i>群发与通知权限</li>
						<li><i class="icon-gou p-r-10"></i>用户管理权限</li>
						<li><i class="icon-gou p-r-10"></i>帐号服务权限</li>
						<li><i class="icon-gou p-r-10"></i>素材管理权限</li>
						<li><i class="icon-gou p-r-10"></i>微信多客服权限</li>
						<li><i class="icon-gou p-r-10"></i>微信小店权限</li>
						<li><i class="icon-gou p-r-10"></i>微信卡券权限</li>
						<li><i class="icon-gou p-r-10"></i>微信门店权限</li>
						<li><i class="icon-gou p-r-10"></i>微信扫一扫权限</li>
						<li><i class="icon-gou p-r-10"></i>微信连WIFI权限</li>
						<li><i class="icon-gou p-r-10"></i>微信摇周边权限</li>
						<li><i class="icon-gou p-r-10"></i>城市服务接口权限</li>
						<li><i class="icon-gou p-r-10"></i>广告管理权限</li>
						<li><i class="icon-gou p-r-10"></i>微信电子发票权限</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'MemberPubilc',
		components: {},
		data() {
			return {
				
			}
		},
		mounted() {
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				publicInfo: state => state.auth.publicInfo
			}),
		},
		/*
		 * 事件处理
		 */
		methods: {
			async handleAuth(){
				const data = await this.getComponentAuthorizationUrl()
				window.location.href = data.componentOauthUrl
			},
			...mapActions(['getComponentAuthorizationUrl']),
		}
	}
</script>

<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	.bor-top-none{
		border-top: none !important;
	}
	.from {
		background: $color-white;
		border: $color-border 1px solid;
		h5{
			color: $color-main;
			padding-bottom: px-em(30px);
			font-size: px-em(32px);
		}
		li{
			padding: px-em(10px) px-em(20px);
			.icon-gou{
				color: $color-green;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// WxAuth.vue?0f33ddec